import { render } from "./RightClickMainMenu.vue?vue&type=template&id=7c4d98fe&scoped=true"
import script from "./RightClickMainMenu.vue?vue&type=script&lang=js"
export * from "./RightClickMainMenu.vue?vue&type=script&lang=js"

import "./RightClickMainMenu.vue?vue&type=style&index=0&id=7c4d98fe&lang=stylus&scoped=true"

import exportComponent from "D:\\01.WorkData\\05.WebProjects\\04.SourceCode\\02.Vue\\project_110_008\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4d98fe"]])

export default __exports__